export const state = {
  plans: {},
  status: "",
  promoCodeError: "",
  promoCode: null,
};
